import { Box, styled } from "@mui/material";

export const StyledFooter = styled(Box)(({ theme }) => ({
  ".footer": {
    background: theme.color.main,
    height: "20rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    h3: {
      color: theme.color.background,
      fontWeight: "600",
    },
    ".text": {
      width: "30rem",
      display: "flex",
      flexDirection: "column",
      gap: "2rem",
      padding: "2rem",
      boxSizing: "border-box",
      p: {
        color: theme.color.background,
      },
    },
    ".divider": {
      height: "70%",
      width: "3px",
      background: theme.color.contrastColor,
    },
    ".infoitem": {
      display: "flex",
      width: "20rem",
      justifyContent: "space-between",
      svg: {
        color: theme.color.background,
      },
      h4: {
        color: theme.color.background,
      },
    },
    ".links": {
      color: theme.color.background,
      width: "20rem",
      h4: {
        fontSize: "1.3rem",
        cursor: "pointer",
        "&:hover": {
          color: theme.color.contrastColor,
        },
      },
    },
  },
  ".copyright": {
    height: "3rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    h5: {
      color: theme.contrast.main,
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.mobile}px)`]: {
    width: "100%",
    ".footer": {
      height: "60rem",
      flexDirection: "column",
      alignItems: "center",
      ".divider": {
        height: "3px",
        width: "70%",
      },
      ".text, .info, .links": {
        alignItems: "center",
        h3: {
          textAlign: "center"
        },
      },
      ".text": {
        width: "90%",
        p: {
          textAlign: "center",
        }
      },
      ".links": {
        color: theme.color.background,
        width: "20rem",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "1rem",
        h3: {
          minWidth: "100%"
        }
      },
    },
    ".copyright": {
      height: "7rem",
      textAlign: "center",
    }
  },
}));
